import { useContext, useState } from "react";
import { NavDropdown } from "react-bootstrap";
import { AuthContext } from "components/Auth/Auth";
import { PasswordModifierModal } from "components/Auth/PasswordModifier";
import { MfaRegistrarModal } from "components/Auth/MfaRegistrar";
import Lang from "components/Lang";

const AuthMenu = () => {
  const auth = useContext(AuthContext);
  if (!auth) {
    return null;
  }
  const {
    user,
    userDisplayName,
    logout,
    // startSetupMfa, 2要素認証のセットアップ
    cancelSetupMfa,
    mfaSecret,
    verifySoftwareToken,
    changePassword
  } = auth;
  const [changingPassword, setChangingPassword] = useState(false);
  return (
    <>
      <NavDropdown title={userDisplayName} align="end" active>
        <NavDropdown.Item as="button" onClick={() => setChangingPassword(true) } >
          <Lang>パスワード変更</Lang>
        </NavDropdown.Item>
        {/* <NavDropdown.Item as="button" onClick={startSetupMfa}>
        2要素認証の設定
        </NavDropdown.Item> */}
        <NavDropdown.Divider />
        <NavDropdown.Item as="button" onClick={logout}>
          <Lang>ログアウト</Lang>
        </NavDropdown.Item>
      </NavDropdown>
      {changingPassword && (
        <PasswordModifierModal
          username={user.username}
          submit={changePassword}
          onExited={() => setChangingPassword(false)}
        />
      )}
      {mfaSecret && (
        <MfaRegistrarModal
          secretCode={mfaSecret}
          username={user.username}
          submit={verifySoftwareToken}
          onExited={() => cancelSetupMfa()}
        />
      )}
    </>
  );
};

export default AuthMenu;